import {
    TIREHOTEL_RECEIVE,
    TIREHOTEL_ERROR,
    TIREHOTEL_HANDLE_CUSTOMER_CHANGE,
    TIREHOTEL_HANDLE_TIRESET_CHANGE,
    TIREHOTEL_HANDLE_TIRE_CHANGE,
} from '../Actions/TireHotel.action'
import { error as errorReducer } from './Error.reducer'

const defaultState = {
    payload: {
        tireHotel: {},
    },
    errors: {},
}

export const tireHotel = (state = defaultState, action) => {
    const { type, payload } = action
    switch (type) {
        case TIREHOTEL_RECEIVE:
            return {
                ...state,
                ...payload,
            }
        case TIREHOTEL_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            }

        case TIREHOTEL_HANDLE_CUSTOMER_CHANGE:
            return {
                ...state,
                payload: {
                    ...state.payload,
                    [payload.key]: {
                        ...state.payload[payload.key],
                        ...payload.data,
                    },
                },
            }

        case TIREHOTEL_HANDLE_TIRESET_CHANGE:
            let tireSetChangeTireSets = [...state.payload[payload.key]]
            tireSetChangeTireSets[payload.index] = {
                ...state.payload[payload.key][payload.index],
                ...payload.data,
            }
            return {
                ...state,
                payload: {
                    ...state.payload,
                    [payload.key]: tireSetChangeTireSets,
                },
            }
        default:
            return state

        case TIREHOTEL_HANDLE_TIRE_CHANGE:
            let tireChangeTireSets = [...state.payload[payload.key]]
            let tires = [
                ...state.payload[payload.key][payload.tireSetIndex]['tires'],
            ]
            tires[payload.index] = {
                ...state.payload[payload.key][payload.tireSetIndex]['tires'][
                    payload.index
                ],
                ...payload.data,
            }
            let tireSetTires = { tires: tires }
            tireChangeTireSets[payload.tireSetIndex] = {
                ...state.payload[payload.key][payload.tireSetIndex],
                ...tireSetTires,
            }
            return {
                ...state,
                payload: {
                    ...state.payload,
                    [payload.key]: tireChangeTireSets,
                },
            }
    }
}
